import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'
import Swal from 'sweetalert2'
import i18next from 'i18next'
const t = (key) => i18next.t(key)

const actions = crud(
	'unit_additional_field',
	'el campo adicional de unidad',
	'loas campos adicionales de unidad'
)

// El load() del CRUD est├índar se utiliza - es actions.load
// Se encarga de hacer GET /unit_additional_field y despachar al reducer

const upsertUnitAdditionalFields = (items) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/unit/upsert_unit_additional_fields`, {
			method: 'PUT',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({ unit_additional_fields: items }),
		})

		Swal.fire({
			title: t('¡Acción Realizada!'),
			text: t('Los campos adicionales se procesaron correctamente.'),
			icon: 'success',
			confirmButtonText: t('OK'),
			showCloseButton: true,
		}).then((result) => {
			if (result.isConfirmed) {
				window.location.reload()
			}
		})

		return res.body
	}
}

const loadUnitAdditionalFieldsValues = (id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/unit/utils/load_unit_additional_fields_values/${id}`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			}
		)

		return res.body
	}
}

const saveUnitAdditionalFieldsValues = (unit_id, fieldsData) => {
	return async (dispatch, getState) => {
		const state = getState()

		// Validar que los datos sean v├ílidos
		if (!fieldsData || fieldsData.length === 0 || !unit_id) {
			return { success: true, message: 'No hay datos para guardar' }
		}

		// Transformar datos para asegurar que tengan los campos correctos
		const fieldsToSave = fieldsData.filter(fieldData => fieldData.unit_additional_field_id).map((fieldData) => ({
			unit_additional_field_id: fieldData.unit_additional_field_id,
			text_value: fieldData.text_value || null,
			number_value: fieldData.number_value || null,
			date_value: fieldData.date_value || null,
		}))

		if (fieldsToSave.length === 0) {
			return { success: true, message: 'Sin campos v├ílidos' }
		}

		try {
			const res = await callApi(
				`/unit_additional_field/save_unit_additional_fields_values`,
				{
					method: 'POST',
					headers: {
						Authorization: state.app.user.token,
					},
					body: JSON.stringify({ unit_id: parseInt(unit_id), fieldsData: fieldsToSave }),
				}
			)

			if (!res.isCustomError) {
				return {
					success: true,
					message: 'Guardado',
					values_saved: res.body?.length || fieldsToSave.length
				}
			} else {
				return { success: false, error: res.body }
			}
		} catch (error) {
			return { success: false, error: error.message }
		}
	}
}

export default {
	...actions,
	// Usar el load() del CRUD que despacha correctamente a Redux
	loadUnitAdditionalFields: actions.load,
	upsertUnitAdditionalFields,
	loadUnitAdditionalFieldsValues,
	saveUnitAdditionalFieldsValues,
}
